import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'

import { Wrapper, ContentWrapper } from './styles'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
const Modal = ({ children, onClose }) => {
  const contentRef = useRef(null)
  const container = document.createElement('div')

  // @ts-expect-error TS(2345) FIXME: Argument of type '() => (() => HTMLDivElement) | u... Remove this comment to see the full error message
  useEffect(() => {
    const modalWrapper = document.getElementById('modal-wrapper')

    if (!modalWrapper) {
      return
    }

    modalWrapper.appendChild(container)

    return () => modalWrapper.removeChild(container)
  }, [children])

  // @ts-expect-error TS(7031) FIXME: Binding element 'target' implicitly has an 'any' t... Remove this comment to see the full error message
  const onClick = ({ target }) => {
    // @ts-expect-error TS(2339) FIXME: Property 'contains' does not exist on type 'never'... Remove this comment to see the full error message
    if (!contentRef.current || contentRef.current.contains(target)) {
      return
    }

    onClose()
  }

  return createPortal(
    <Wrapper onClick={onClick} role="dialog" aria-modal="true">
      <ContentWrapper ref={contentRef}>{children}</ContentWrapper>
    </Wrapper>,
    container,
    'modal',
  )
}

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onClose: PropTypes.func,
}

Modal.defaultProps = {
  onClose: null,
}

export default Modal
